// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1H3sX","content":"styles_content__C1tvS"};